export const ROUTE_SET = 'admin-event.ROUTE_SET'
export const ERROR_SET = 'admin-event.ERROR_SET'
export const LOADING_SET = 'admin-event.LOADING_SET'
export const KEYWORD_SET = 'admin-event.KEYWORD_SET'
export const EVENTS_SET = 'admin-event.EVENTS_SET'
export const PURCHASE_SET = 'admin-event.PURCHASE_SET'
